import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { WarehouseModel } from "@insite/client-framework/Types/ApiModels";
import { CustomHandler } from "@thos/Store/CustomHandlerCreator";

type HandlerType = CustomHandler<{ selectedShipFromWarehouse?: WarehouseModel }>;

const DispatchSetSelectedShipFromWarehouse: HandlerType = props => {
    props.dispatch({
        type: "Custom/ShipFromWarehouse/SetSelectedShipFromWarehouse",
        selectedShipFromWarehouse: props.parameter.selectedShipFromWarehouse
    })
}
export const chain = [DispatchSetSelectedShipFromWarehouse];

const setSelectedShipFromWarehouse = createHandlerChainRunner(chain, "SetSelectedShipFromWarehouse");
export default setSelectedShipFromWarehouse;